export default "<template>\n\n  <KIcon\n    icon=\"allActivities\"\n    color=\"green\"\n  />\n\n</template>\n";